import { render, staticRenderFns } from "./EditGoal.vue?vue&type=template&id=7d8940d1"
import script from "./EditGoal.vue?vue&type=script&lang=js"
export * from "./EditGoal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports